import LatLng, { LatLngLike } from './latLng'

// Vendored from google-map-react v1's lib/utils/lib_geo/lat_lng_bounds.js.
// Pure geo helper used before the Google Maps API loads (the Map's default
// bounds state, centerFromBounds); v2 no longer exposes it. Accepts plain
// coord tuples as well as LatLng instances.
export default class LatLngBounds {
  southWest?: LatLng

  northEast?: LatLng

  constructor(sw?: LatLngLike, ne?: LatLngLike) {
    if (sw) this.extend(sw)
    if (ne) this.extend(ne)
  }

  extend(obj: LatLngLike | LatLngBounds): this {
    let sw: LatLng
    let ne: LatLng

    if (obj instanceof LatLngBounds) {
      if (!obj.southWest || !obj.northEast) return this
      sw = obj.southWest
      ne = obj.northEast
    } else {
      sw = LatLng.convert(obj)
      ne = sw
    }

    if (!this.southWest || !this.northEast) {
      this.southWest = new LatLng(sw.lat, sw.lng)
      this.northEast = new LatLng(ne.lat, ne.lng)
    } else {
      this.southWest.lat = Math.min(sw.lat, this.southWest.lat)
      this.southWest.lng = Math.min(sw.lng, this.southWest.lng)
      this.northEast.lat = Math.max(ne.lat, this.northEast.lat)
      this.northEast.lng = Math.max(ne.lng, this.northEast.lng)
    }
    return this
  }

  getCenter(): LatLng {
    if (!this.southWest || !this.northEast) {
      throw new Error('Cannot get the center of empty LatLngBounds')
    }
    return new LatLng(
      (this.southWest.lat + this.northEast.lat) / 2,
      (this.southWest.lng + this.northEast.lng) / 2,
    )
  }
}
